import React from 'react';
import { Finding } from './contentAudit.types';
import FindingList from './FindingList';

interface Props {
  editHref?: string;
  findings: Finding[];
  slug: string;
}

// SPA fork of admin/ContentAudit/SectionGroup — an editorial slug anchoring its findings.
const SPASectionGroup = ({ editHref, findings, slug }: Props) => (
  <div className="tw-flex tw-flex-col tw-gap-3">
    <div
      className={[
        'tw-flex tw-items-baseline tw-justify-between tw-gap-4',
        'tw-border-0 tw-border-b tw-border-solid tw-border-spa-border tw-pb-1.5',
      ].join(' ')}
    >
      <h3 className="tw-m-0 tw-text-lg tw-font-semibold tw-leading-6 tw-text-spa-on-bg">{slug}</h3>
      {editHref && (
        <a
          className={[
            'tw-shrink-0 tw-text-xs tw-font-semibold tw-text-spa-accent-text',
            'tw-no-underline hover:tw-underline',
          ].join(' ')}
          href={editHref}
          rel="noreferrer"
          target="_blank"
        >
          Edit section ↗
        </a>
      )}
    </div>
    <FindingList findings={findings} />
  </div>
);

export default SPASectionGroup;
